// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"135":"hlsjs","362":"vttjs","779":"panolens","798":"dashjs","959":"webvtt"}[chunkId] || chunkId) + "." + {"135":"035002d6","362":"add1d5db","453":"46957750","501":"ee8a68ce","779":"925a135b","798":"c8f77609","959":"41b61ec0"}[chunkId] + ".chunk.js";
};